import { InjectionToken } from '@angular/core';

export interface FirebaseAuthConfig {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
}

export interface SharedEnvironment {
  host: string;
  gtnHost?: string;
  throttleKey?: string;
  extensionHost: string;
  uploadHostUrl: string;
  production: boolean;
  beErrorLangKey: string;
  reCaptchaSiteKey: string;
  defaultLang: string;
  socketUrl?: string;
  firebaseAuth?: FirebaseAuthConfig;
}

export const SHARED_ENV = new InjectionToken<SharedEnvironment>('shared.env');
